import { render, staticRenderFns } from "./itemStoreInfo.vue?vue&type=template&id=3ae0a1b6"
import script from "./itemStoreInfo.vue?vue&type=script&lang=js"
export * from "./itemStoreInfo.vue?vue&type=script&lang=js"
import style0 from "./itemStoreInfo.vue?vue&type=style&index=0&id=3ae0a1b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports